import {
    tourbillon,
    pingpong,
    memory,
    sudok,
    puzzle,
    reordon,
    melimots,
    quizz,
    codeExpress,
    Game
} from '../models/Games';

export const GAME_MAP: Record<string, Game> = {
    tourbillon,
    pingpong,
    memory,
    sudok,
    puzzle,
    reordon,
    melimots,
    quizz,
    'code-express': codeExpress
};

export const FIND_ANOTHER_GAME_TYPES: string[] = [];

export const LANDSCAPE_ONLY_GAMES = ['pingpong'];

export const GAMES_WITH_SCROLL: string[] = [];
